import * as Inovx from '@shared';
import BaseService from '@shared/services/BaseService';

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var roleUrl = `${UrlUtilities.getApiUrl()}/OrganizationApi/api/role`;
var url = `${UrlUtilities.getApiUrl()}/OrganizationApi/api/organization`;

var OrganizationServices: IOrganizationService = {
    ...BaseService,

    getAllRoot: function (itemType: number, successCallback: (retData: IOrganizationBase[]) => void, errorCallback: IErrorCallback, ignoreDefaultError?: boolean) {
        this.get(`${url}/RootItems`,
            { itemType: itemType },
            (retData: IOrganizationBase[]) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                if (!ignoreDefaultError) {
                    this.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    getChildren: function (organization: IOrganizationBase, successCallback: (retData: IOrganizationBase[]) => void, errorCallback: IErrorCallback) {
        this.get(`${url}/ChildrenItems`,
            { id: organization.ID, itemType: 3 },
            (retData: IOrganizationBase[]) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },

    getOrganizationDetail: function (id: string, successCallback: (retData: IItemDataDetail) => void, errorCallback: IErrorCallback) {
        this.get(`${url}/ItemDetail`,
            { id: id, itemType: 5 },
            (retData: IItemDataDetail) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    },

    editOrganization: function (itemDetail: IItemDataDetail, successCallback: (retData: IItemDataDetail) => void, errorCallback: IErrorCallback) {
        this.post(`${url}/UpdateItem`,
            itemDetail,
            (retData: IItemDataDetail) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);

            });
    },

    getAllRoles: function (successCallback: (retData: IOrganizationRole[]) => void, errorCallback: IErrorCallback) {
        this.get(roleUrl,
            null,
            (retData: IOrganizationRole[]) => {
                successCallback(retData);
            },
            (error: IServiceErrorObject) => {
                this.handleWebApiError(error);
                errorCallback(error);
            });
    }
};

export default OrganizationServices;
